<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .user {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: utils.in_rem(12px);

    h4 {
      @include colors.color(textLighterBlack);
      @include mixins.h4();
    }
  }
</style>

<script>
  import Avatar from "@sourcewhale/shared/svelte-design-system/components/atoms/Avatar.svelte";

  let { user, skeleton = false } = $props();

  const src = $derived(user?.picture);
  const name = $derived(skeleton ? "Loading..." : user?.name || "");
  const split = $derived(name.split(" "));
  const firstName = $derived(split[0]);
  const lastName = $derived(split.length > 1 ? split.at(-1) : "");
</script>

<div class="user">
  <Avatar size="medium" {skeleton} {src} {firstName} {lastName} />
  <div class="name">
    <h4 class:skeleton>{name}</h4>
  </div>
</div>
